import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'logo-row',
  styleUrl: 'logo-row.css',
  shadow: true,
})
export class LogoRow {
  /**
   * The title
   */
  @Prop() logoRow: string;
  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.logo-grid'),
      () => {
        this.el.shadowRoot.querySelector('.logo-grid').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4', '.overlay5', '.overlay6', '.overlay7', '.overlay8'],
    );
  }
  render() {
    const logoRow = JSON.parse(this.logoRow);
    //console.log(logoRow)
    const count = logoRow.length;
    return (
      <Host>
        <section class={` ${this.backgroundColor}`} style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          <div class={`container flex items-center relative   justify-center ${this.paddingBottom} ${this.paddingTop} layout-${count}`}>
            <div class={`logo-grid logo-layout-${count} `}>
              {logoRow.map((logo, index) => (
                <div class={`grid-item logo-container`}>
                  <div class={`overlay${index + 1} ${this.backgroundColor}`}></div>
                  {/* <image-block imageUrl={logo.url} imageAlt={logo.alt ? logo.alt : 'company logo'} imageClass=""></image-block> */}
                  <img src={logo.url} alt={logo.alt ? logo.alt : 'company logo'} width="250" height="250" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
